import { withAsync } from '@helpcenter/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

const loader = lazyForPaint(() => import(/* webpackChunkName: "user-profile" */ './hocs'));
export const UserProfile = withAsync({
    loader,
});
